import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'qaroni-title-md',
  templateUrl: './title-md.component.html',
  styleUrls: ['./title-md.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TitleMdComponent {}
